import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=6681a8fe&scoped=true"
import script from "./FilterMenu.vue?vue&type=script&lang=ts"
export * from "./FilterMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681a8fe",
  null
  
)

export default component.exports